import {useEffect, useState} from "react";
import axios from "axios";

// custom hook for performing GET request
const useFetch = (url, initialValue, params = {}, auto = true) => {
  const [data, setData] = useState(initialValue);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = async function () {
    try {
      setLoading(true);
      const response = await axios.get(url, {params: params});
      if (response.status === 200) {
        setData(response.data);
        setError(null);
      }
    } catch (err) {
      // Como en useGet, el error queda en el estado en vez de quedar como rechazo sin atrapar. Un 401 ya lo resuelve el
      // interceptor de axios (manda a /logout).
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Pide los datos al montar y al cambiar la URL; el setLoading(true) sincrónico es el inicio de esa misma carga.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    if(auto) fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);

  return {loading, data, error, fetchData};
};

export default useFetch;
